var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructuredProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 324.4 284.07",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6,.cls-9{fill:none;}.cls-1{stroke:#154e1a;stroke-width:2.24px;stroke-dasharray:11.21;opacity:0.25;isolation:isolate;}.cls-2{fill:#0d30ba;}.cls-3,.cls-8{fill:#f4f4f4;}.cls-4{fill:#0d16ee;}.cls-5{fill:#fff;}.cls-7{fill:#15341a;}.cls-8,.cls-9{stroke:#0d30ba;stroke-width:8.97px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.12,
    y: 74.66,
    width: 306.04,
    height: 208.28,
    rx: 5.61,
    ry: 5.61
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.92,84.21,236.69,44.93A7.47,7.47,0,0,0,231.8,43H148.39a6.92,6.92,0,0,0-7,7.1V75.46h14l80.14,131.1v14.2H273a6.92,6.92,0,0,0,7-7.1V89.42A7.41,7.41,0,0,0,277.92,84.21Z",
    style: {
      fill: "rgb(14, 72, 198)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M191.63,76.75l41.24,39.31a7.39,7.39,0,0,1,2.1,5.21V206h30.52V91.9l-3.26-3.07-31-29.61-2.8-2.6H154.82V74.85h31.92A7.43,7.43,0,0,1,191.63,76.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.42,204.7V120a7.42,7.42,0,0,0-2.09-5.2L193.09,75.49a7.47,7.47,0,0,0-4.89-1.89H104.8a6.92,6.92,0,0,0-7,7.1V244.22a6.92,6.92,0,0,0,7,7.1H229.43a6.92,6.92,0,0,0,7-7.1V204.7Z",
    style: {
      fill: "rgb(14, 72, 198)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.76,89.79,186,87.18H112.34V236.61H223V122.47l-3.26-3.08Z",
    style: {
      fill: "rgb(62, 112, 220)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.24,129.07h33.44a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4H125.24a4,4,0,0,1-4-4h0A4,4,0,0,1,125.24,129.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.24,150.57h41.27a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4H125.24a4,4,0,0,1-4-4h0A4,4,0,0,1,125.24,150.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.24,172.08H152a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4H125.24a4,4,0,0,1-4-4h0A4,4,0,0,1,125.24,172.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.67,129.07h12.2a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4h-12.2a4,4,0,0,1-4-4h0A4,4,0,0,1,195.67,129.07Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.67,150.57h12.2a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4h-12.2a4,4,0,0,1-4-4h0A4,4,0,0,1,195.67,150.57Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.32,172.08h15.55a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4H192.32a4,4,0,0,1-4-4h0A4,4,0,0,1,192.32,172.08Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.32,207.17h15.55a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4H192.32a4,4,0,0,1-4-4h0A4,4,0,0,1,192.32,207.17Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.24,210.57h15.55a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4H125.24a4,4,0,0,1-4-4h0A4,4,0,0,1,125.24,210.57Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 40,
    y: 4,
    width: 122.62,
    height: 124.16
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95,123.46c-33.61,0-61-27.69-61-61.73S61.35,0,95,0s61,27.69,61,61.73S128.58,123.46,95,123.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M118.1,90.41A36.36,36.36,0,0,1,95,98.77c-20.16,0-36.58-16.62-36.58-37A37.42,37.42,0,0,1,66.64,38.3l-6.29-5.22A45.73,45.73,0,0,0,50.26,61.73c0,25,20.05,45.27,44.7,45.27a44.41,44.41,0,0,0,28.29-10.23Z",
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M95,24.69c20.17,0,36.58,16.62,36.58,37a37.42,37.42,0,0,1-8.26,23.43l6.29,5.22a45.72,45.72,0,0,0,10.1-28.65c0-25-20.06-45.27-44.71-45.27A44.43,44.43,0,0,0,66.67,26.69l5.15,6.37A36.33,36.33,0,0,1,95,24.69Z",
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.35,45.57H83.67v6.7H87.4c3.49,0,5.72.8,6.52,3.15h-6l-4.24.34v3.9H94c-.74,2.69-3,4.06-6.58,4.06H83.67v6.7h4.07l8.19,11.52h9.45L95.59,69a11.14,11.14,0,0,0,6.75-9.33h4V55.42h-4.06a8.59,8.59,0,0,0-3.5-5.61h7.56Z",
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M307.06,100.7a13,13,0,1,0-12.85-13A12.94,12.94,0,0,0,307.06,100.7Z",
    style: {
      paintOrder: "fill",
      stroke: "rgb(14, 72, 198)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.91,260.19a13,13,0,1,0-12.85-13A12.94,12.94,0,0,0,33.91,260.19Z",
    style: {
      stroke: "rgb(14, 72, 198)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.42,242.27V231.63h10.05v-6H310.42V215h-6.17v10.64h-10v6h10v10.64Z",
    style: {
      fill: "rgb(14, 72, 198)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63.19,171.6V161h10v-6h-10V144.32H57V155H47v6H57V171.6Z",
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructuredProduct);
export default __webpack_public_path__ + "static/media/StructuredProduct.caa262a5e5b3496abc839fbb0ef97d6f.svg";
export { ForwardRef as ReactComponent };